module.exports = __webpack_public_path__ + "img/milenium.6015e7a5.jpeg";